export const LEFT_KEY = 'ArrowLeft';
export const RIGHT_KEY = 'ArrowRight';
export const TAB_KEY = 'Tab';
export const ENTER_KEY = 'Enter';

export const DragTypes = {
  MENUINPUT: 'menuInput',
  MENUSTRUCTURE: 'menuStructure',
  FORMSTRUCTURE: 'formStructure',
  FORMINPUT: 'formInput',
};
